/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TestImport } from './routes/test'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as LoginImport } from './routes/login'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as ConfirmRegistrationImport } from './routes/confirm-registration'
import { Route as IndexImport } from './routes/index'
import { Route as DashboardIndexImport } from './routes/dashboard/index'
import { Route as DashboardVariantsIndexImport } from './routes/dashboard/variants/index'
import { Route as DashboardUsersIndexImport } from './routes/dashboard/users/index'
import { Route as DashboardSkinsIndexImport } from './routes/dashboard/skins/index'
import { Route as DashboardMediaIndexImport } from './routes/dashboard/media/index'
import { Route as DashboardGamesIndexImport } from './routes/dashboard/games/index'
import { Route as DashboardEventsIndexImport } from './routes/dashboard/events/index'
import { Route as DashboardVariantsNewImport } from './routes/dashboard/variants/new'
import { Route as DashboardUsersNewImport } from './routes/dashboard/users/new'
import { Route as DashboardUsersIdImport } from './routes/dashboard/users/$id'
import { Route as DashboardSkinsNewImport } from './routes/dashboard/skins/new'
import { Route as DashboardGamesNewImport } from './routes/dashboard/games/new'
import { Route as DashboardEventsNewImport } from './routes/dashboard/events/new'
import { Route as DashboardVariantsEditIdImport } from './routes/dashboard/variants/edit/$id'
import { Route as DashboardSkinsEditIdImport } from './routes/dashboard/skins/edit/$id'
import { Route as DashboardGamesEditIdImport } from './routes/dashboard/games/edit/$id'
import { Route as DashboardEventsViewIdImport } from './routes/dashboard/events/view/$id'
import { Route as DashboardEventsEditIdImport } from './routes/dashboard/events/edit/$id'

// Create/Update Routes

const TestRoute = TestImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const ConfirmRegistrationRoute = ConfirmRegistrationImport.update({
  id: '/confirm-registration',
  path: '/confirm-registration',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardIndexRoute = DashboardIndexImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardVariantsIndexRoute = DashboardVariantsIndexImport.update({
  id: '/dashboard/variants/',
  path: '/dashboard/variants/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardUsersIndexRoute = DashboardUsersIndexImport.update({
  id: '/dashboard/users/',
  path: '/dashboard/users/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardSkinsIndexRoute = DashboardSkinsIndexImport.update({
  id: '/dashboard/skins/',
  path: '/dashboard/skins/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardMediaIndexRoute = DashboardMediaIndexImport.update({
  id: '/dashboard/media/',
  path: '/dashboard/media/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardGamesIndexRoute = DashboardGamesIndexImport.update({
  id: '/dashboard/games/',
  path: '/dashboard/games/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardEventsIndexRoute = DashboardEventsIndexImport.update({
  id: '/dashboard/events/',
  path: '/dashboard/events/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardVariantsNewRoute = DashboardVariantsNewImport.update({
  id: '/dashboard/variants/new',
  path: '/dashboard/variants/new',
  getParentRoute: () => rootRoute,
} as any)

const DashboardUsersNewRoute = DashboardUsersNewImport.update({
  id: '/dashboard/users/new',
  path: '/dashboard/users/new',
  getParentRoute: () => rootRoute,
} as any)

const DashboardUsersIdRoute = DashboardUsersIdImport.update({
  id: '/dashboard/users/$id',
  path: '/dashboard/users/$id',
  getParentRoute: () => rootRoute,
} as any)

const DashboardSkinsNewRoute = DashboardSkinsNewImport.update({
  id: '/dashboard/skins/new',
  path: '/dashboard/skins/new',
  getParentRoute: () => rootRoute,
} as any)

const DashboardGamesNewRoute = DashboardGamesNewImport.update({
  id: '/dashboard/games/new',
  path: '/dashboard/games/new',
  getParentRoute: () => rootRoute,
} as any)

const DashboardEventsNewRoute = DashboardEventsNewImport.update({
  id: '/dashboard/events/new',
  path: '/dashboard/events/new',
  getParentRoute: () => rootRoute,
} as any)

const DashboardVariantsEditIdRoute = DashboardVariantsEditIdImport.update({
  id: '/dashboard/variants/edit/$id',
  path: '/dashboard/variants/edit/$id',
  getParentRoute: () => rootRoute,
} as any)

const DashboardSkinsEditIdRoute = DashboardSkinsEditIdImport.update({
  id: '/dashboard/skins/edit/$id',
  path: '/dashboard/skins/edit/$id',
  getParentRoute: () => rootRoute,
} as any)

const DashboardGamesEditIdRoute = DashboardGamesEditIdImport.update({
  id: '/dashboard/games/edit/$id',
  path: '/dashboard/games/edit/$id',
  getParentRoute: () => rootRoute,
} as any)

const DashboardEventsViewIdRoute = DashboardEventsViewIdImport.update({
  id: '/dashboard/events/view/$id',
  path: '/dashboard/events/view/$id',
  getParentRoute: () => rootRoute,
} as any)

const DashboardEventsEditIdRoute = DashboardEventsEditIdImport.update({
  id: '/dashboard/events/edit/$id',
  path: '/dashboard/events/edit/$id',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/confirm-registration': {
      id: '/confirm-registration'
      path: '/confirm-registration'
      fullPath: '/confirm-registration'
      preLoaderRoute: typeof ConfirmRegistrationImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/events/new': {
      id: '/dashboard/events/new'
      path: '/dashboard/events/new'
      fullPath: '/dashboard/events/new'
      preLoaderRoute: typeof DashboardEventsNewImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/games/new': {
      id: '/dashboard/games/new'
      path: '/dashboard/games/new'
      fullPath: '/dashboard/games/new'
      preLoaderRoute: typeof DashboardGamesNewImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/skins/new': {
      id: '/dashboard/skins/new'
      path: '/dashboard/skins/new'
      fullPath: '/dashboard/skins/new'
      preLoaderRoute: typeof DashboardSkinsNewImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/users/$id': {
      id: '/dashboard/users/$id'
      path: '/dashboard/users/$id'
      fullPath: '/dashboard/users/$id'
      preLoaderRoute: typeof DashboardUsersIdImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/users/new': {
      id: '/dashboard/users/new'
      path: '/dashboard/users/new'
      fullPath: '/dashboard/users/new'
      preLoaderRoute: typeof DashboardUsersNewImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/variants/new': {
      id: '/dashboard/variants/new'
      path: '/dashboard/variants/new'
      fullPath: '/dashboard/variants/new'
      preLoaderRoute: typeof DashboardVariantsNewImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/events/': {
      id: '/dashboard/events/'
      path: '/dashboard/events'
      fullPath: '/dashboard/events'
      preLoaderRoute: typeof DashboardEventsIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/games/': {
      id: '/dashboard/games/'
      path: '/dashboard/games'
      fullPath: '/dashboard/games'
      preLoaderRoute: typeof DashboardGamesIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/media/': {
      id: '/dashboard/media/'
      path: '/dashboard/media'
      fullPath: '/dashboard/media'
      preLoaderRoute: typeof DashboardMediaIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/skins/': {
      id: '/dashboard/skins/'
      path: '/dashboard/skins'
      fullPath: '/dashboard/skins'
      preLoaderRoute: typeof DashboardSkinsIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/users/': {
      id: '/dashboard/users/'
      path: '/dashboard/users'
      fullPath: '/dashboard/users'
      preLoaderRoute: typeof DashboardUsersIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/variants/': {
      id: '/dashboard/variants/'
      path: '/dashboard/variants'
      fullPath: '/dashboard/variants'
      preLoaderRoute: typeof DashboardVariantsIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/events/edit/$id': {
      id: '/dashboard/events/edit/$id'
      path: '/dashboard/events/edit/$id'
      fullPath: '/dashboard/events/edit/$id'
      preLoaderRoute: typeof DashboardEventsEditIdImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/events/view/$id': {
      id: '/dashboard/events/view/$id'
      path: '/dashboard/events/view/$id'
      fullPath: '/dashboard/events/view/$id'
      preLoaderRoute: typeof DashboardEventsViewIdImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/games/edit/$id': {
      id: '/dashboard/games/edit/$id'
      path: '/dashboard/games/edit/$id'
      fullPath: '/dashboard/games/edit/$id'
      preLoaderRoute: typeof DashboardGamesEditIdImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/skins/edit/$id': {
      id: '/dashboard/skins/edit/$id'
      path: '/dashboard/skins/edit/$id'
      fullPath: '/dashboard/skins/edit/$id'
      preLoaderRoute: typeof DashboardSkinsEditIdImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/variants/edit/$id': {
      id: '/dashboard/variants/edit/$id'
      path: '/dashboard/variants/edit/$id'
      fullPath: '/dashboard/variants/edit/$id'
      preLoaderRoute: typeof DashboardVariantsEditIdImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/confirm-registration': typeof ConfirmRegistrationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/test': typeof TestRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/events/new': typeof DashboardEventsNewRoute
  '/dashboard/games/new': typeof DashboardGamesNewRoute
  '/dashboard/skins/new': typeof DashboardSkinsNewRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/users/new': typeof DashboardUsersNewRoute
  '/dashboard/variants/new': typeof DashboardVariantsNewRoute
  '/dashboard/events': typeof DashboardEventsIndexRoute
  '/dashboard/games': typeof DashboardGamesIndexRoute
  '/dashboard/media': typeof DashboardMediaIndexRoute
  '/dashboard/skins': typeof DashboardSkinsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/variants': typeof DashboardVariantsIndexRoute
  '/dashboard/events/edit/$id': typeof DashboardEventsEditIdRoute
  '/dashboard/events/view/$id': typeof DashboardEventsViewIdRoute
  '/dashboard/games/edit/$id': typeof DashboardGamesEditIdRoute
  '/dashboard/skins/edit/$id': typeof DashboardSkinsEditIdRoute
  '/dashboard/variants/edit/$id': typeof DashboardVariantsEditIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/confirm-registration': typeof ConfirmRegistrationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/test': typeof TestRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/events/new': typeof DashboardEventsNewRoute
  '/dashboard/games/new': typeof DashboardGamesNewRoute
  '/dashboard/skins/new': typeof DashboardSkinsNewRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/users/new': typeof DashboardUsersNewRoute
  '/dashboard/variants/new': typeof DashboardVariantsNewRoute
  '/dashboard/events': typeof DashboardEventsIndexRoute
  '/dashboard/games': typeof DashboardGamesIndexRoute
  '/dashboard/media': typeof DashboardMediaIndexRoute
  '/dashboard/skins': typeof DashboardSkinsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/variants': typeof DashboardVariantsIndexRoute
  '/dashboard/events/edit/$id': typeof DashboardEventsEditIdRoute
  '/dashboard/events/view/$id': typeof DashboardEventsViewIdRoute
  '/dashboard/games/edit/$id': typeof DashboardGamesEditIdRoute
  '/dashboard/skins/edit/$id': typeof DashboardSkinsEditIdRoute
  '/dashboard/variants/edit/$id': typeof DashboardVariantsEditIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/confirm-registration': typeof ConfirmRegistrationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/test': typeof TestRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/events/new': typeof DashboardEventsNewRoute
  '/dashboard/games/new': typeof DashboardGamesNewRoute
  '/dashboard/skins/new': typeof DashboardSkinsNewRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/users/new': typeof DashboardUsersNewRoute
  '/dashboard/variants/new': typeof DashboardVariantsNewRoute
  '/dashboard/events/': typeof DashboardEventsIndexRoute
  '/dashboard/games/': typeof DashboardGamesIndexRoute
  '/dashboard/media/': typeof DashboardMediaIndexRoute
  '/dashboard/skins/': typeof DashboardSkinsIndexRoute
  '/dashboard/users/': typeof DashboardUsersIndexRoute
  '/dashboard/variants/': typeof DashboardVariantsIndexRoute
  '/dashboard/events/edit/$id': typeof DashboardEventsEditIdRoute
  '/dashboard/events/view/$id': typeof DashboardEventsViewIdRoute
  '/dashboard/games/edit/$id': typeof DashboardGamesEditIdRoute
  '/dashboard/skins/edit/$id': typeof DashboardSkinsEditIdRoute
  '/dashboard/variants/edit/$id': typeof DashboardVariantsEditIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/confirm-registration'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/test'
    | '/dashboard'
    | '/dashboard/events/new'
    | '/dashboard/games/new'
    | '/dashboard/skins/new'
    | '/dashboard/users/$id'
    | '/dashboard/users/new'
    | '/dashboard/variants/new'
    | '/dashboard/events'
    | '/dashboard/games'
    | '/dashboard/media'
    | '/dashboard/skins'
    | '/dashboard/users'
    | '/dashboard/variants'
    | '/dashboard/events/edit/$id'
    | '/dashboard/events/view/$id'
    | '/dashboard/games/edit/$id'
    | '/dashboard/skins/edit/$id'
    | '/dashboard/variants/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/confirm-registration'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/test'
    | '/dashboard'
    | '/dashboard/events/new'
    | '/dashboard/games/new'
    | '/dashboard/skins/new'
    | '/dashboard/users/$id'
    | '/dashboard/users/new'
    | '/dashboard/variants/new'
    | '/dashboard/events'
    | '/dashboard/games'
    | '/dashboard/media'
    | '/dashboard/skins'
    | '/dashboard/users'
    | '/dashboard/variants'
    | '/dashboard/events/edit/$id'
    | '/dashboard/events/view/$id'
    | '/dashboard/games/edit/$id'
    | '/dashboard/skins/edit/$id'
    | '/dashboard/variants/edit/$id'
  id:
    | '__root__'
    | '/'
    | '/confirm-registration'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/test'
    | '/dashboard/'
    | '/dashboard/events/new'
    | '/dashboard/games/new'
    | '/dashboard/skins/new'
    | '/dashboard/users/$id'
    | '/dashboard/users/new'
    | '/dashboard/variants/new'
    | '/dashboard/events/'
    | '/dashboard/games/'
    | '/dashboard/media/'
    | '/dashboard/skins/'
    | '/dashboard/users/'
    | '/dashboard/variants/'
    | '/dashboard/events/edit/$id'
    | '/dashboard/events/view/$id'
    | '/dashboard/games/edit/$id'
    | '/dashboard/skins/edit/$id'
    | '/dashboard/variants/edit/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConfirmRegistrationRoute: typeof ConfirmRegistrationRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TestRoute: typeof TestRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardEventsNewRoute: typeof DashboardEventsNewRoute
  DashboardGamesNewRoute: typeof DashboardGamesNewRoute
  DashboardSkinsNewRoute: typeof DashboardSkinsNewRoute
  DashboardUsersIdRoute: typeof DashboardUsersIdRoute
  DashboardUsersNewRoute: typeof DashboardUsersNewRoute
  DashboardVariantsNewRoute: typeof DashboardVariantsNewRoute
  DashboardEventsIndexRoute: typeof DashboardEventsIndexRoute
  DashboardGamesIndexRoute: typeof DashboardGamesIndexRoute
  DashboardMediaIndexRoute: typeof DashboardMediaIndexRoute
  DashboardSkinsIndexRoute: typeof DashboardSkinsIndexRoute
  DashboardUsersIndexRoute: typeof DashboardUsersIndexRoute
  DashboardVariantsIndexRoute: typeof DashboardVariantsIndexRoute
  DashboardEventsEditIdRoute: typeof DashboardEventsEditIdRoute
  DashboardEventsViewIdRoute: typeof DashboardEventsViewIdRoute
  DashboardGamesEditIdRoute: typeof DashboardGamesEditIdRoute
  DashboardSkinsEditIdRoute: typeof DashboardSkinsEditIdRoute
  DashboardVariantsEditIdRoute: typeof DashboardVariantsEditIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConfirmRegistrationRoute: ConfirmRegistrationRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TestRoute: TestRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardEventsNewRoute: DashboardEventsNewRoute,
  DashboardGamesNewRoute: DashboardGamesNewRoute,
  DashboardSkinsNewRoute: DashboardSkinsNewRoute,
  DashboardUsersIdRoute: DashboardUsersIdRoute,
  DashboardUsersNewRoute: DashboardUsersNewRoute,
  DashboardVariantsNewRoute: DashboardVariantsNewRoute,
  DashboardEventsIndexRoute: DashboardEventsIndexRoute,
  DashboardGamesIndexRoute: DashboardGamesIndexRoute,
  DashboardMediaIndexRoute: DashboardMediaIndexRoute,
  DashboardSkinsIndexRoute: DashboardSkinsIndexRoute,
  DashboardUsersIndexRoute: DashboardUsersIndexRoute,
  DashboardVariantsIndexRoute: DashboardVariantsIndexRoute,
  DashboardEventsEditIdRoute: DashboardEventsEditIdRoute,
  DashboardEventsViewIdRoute: DashboardEventsViewIdRoute,
  DashboardGamesEditIdRoute: DashboardGamesEditIdRoute,
  DashboardSkinsEditIdRoute: DashboardSkinsEditIdRoute,
  DashboardVariantsEditIdRoute: DashboardVariantsEditIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/confirm-registration",
        "/forgot-password",
        "/login",
        "/reset-password",
        "/test",
        "/dashboard/",
        "/dashboard/events/new",
        "/dashboard/games/new",
        "/dashboard/skins/new",
        "/dashboard/users/$id",
        "/dashboard/users/new",
        "/dashboard/variants/new",
        "/dashboard/events/",
        "/dashboard/games/",
        "/dashboard/media/",
        "/dashboard/skins/",
        "/dashboard/users/",
        "/dashboard/variants/",
        "/dashboard/events/edit/$id",
        "/dashboard/events/view/$id",
        "/dashboard/games/edit/$id",
        "/dashboard/skins/edit/$id",
        "/dashboard/variants/edit/$id"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/confirm-registration": {
      "filePath": "confirm-registration.tsx"
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/test": {
      "filePath": "test.tsx"
    },
    "/dashboard/": {
      "filePath": "dashboard/index.tsx"
    },
    "/dashboard/events/new": {
      "filePath": "dashboard/events/new.tsx"
    },
    "/dashboard/games/new": {
      "filePath": "dashboard/games/new.tsx"
    },
    "/dashboard/skins/new": {
      "filePath": "dashboard/skins/new.tsx"
    },
    "/dashboard/users/$id": {
      "filePath": "dashboard/users/$id.tsx"
    },
    "/dashboard/users/new": {
      "filePath": "dashboard/users/new.tsx"
    },
    "/dashboard/variants/new": {
      "filePath": "dashboard/variants/new.tsx"
    },
    "/dashboard/events/": {
      "filePath": "dashboard/events/index.tsx"
    },
    "/dashboard/games/": {
      "filePath": "dashboard/games/index.tsx"
    },
    "/dashboard/media/": {
      "filePath": "dashboard/media/index.tsx"
    },
    "/dashboard/skins/": {
      "filePath": "dashboard/skins/index.tsx"
    },
    "/dashboard/users/": {
      "filePath": "dashboard/users/index.tsx"
    },
    "/dashboard/variants/": {
      "filePath": "dashboard/variants/index.tsx"
    },
    "/dashboard/events/edit/$id": {
      "filePath": "dashboard/events/edit/$id.tsx"
    },
    "/dashboard/events/view/$id": {
      "filePath": "dashboard/events/view/$id.tsx"
    },
    "/dashboard/games/edit/$id": {
      "filePath": "dashboard/games/edit/$id.tsx"
    },
    "/dashboard/skins/edit/$id": {
      "filePath": "dashboard/skins/edit/$id.tsx"
    },
    "/dashboard/variants/edit/$id": {
      "filePath": "dashboard/variants/edit/$id.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
